module.exports = __webpack_public_path__ + "img/operation-play.bddeac28.png";